// components/common/sections/CollectionsSection.tsx
"use client";
import Link from "next/link";
import { Button } from "../../shadcn/button";
import { ChevronRight } from "lucide-react";
import CollectionsSwiper from "../../elements/swipers/CollectionsSwiper";
import { CollectionSection } from "@/app/lib/features/home/home.types";
import { trackSectionClick } from "@/app/lib/tracking/interactions";
import { useTrackView } from "@/app/hooks/useTrackView";

interface CollectionsSectionProps {
  section: CollectionSection;
}

const CollectionsSection = ({ section }: CollectionsSectionProps) => {
  const { id, title, link, items } = section;
  const trackRef = useTrackView("section", id);

  if (!items || items.length === 0) return null;

  return (
    <section
      ref={trackRef}
      className="border border-muted p-2 sm:p-4 rounded-md"
      style={{
        background:
          "linear-gradient(rgba(255,255,255,0) 10.75%,#fff 85.25%),linear-gradient(88deg,#ffecdf 2.4%,#ffd4c1 50%,#ffd7d7 98.61%)",
      }}
    >
      <div className="flex items-center justify-between mb-2 sm:mb-3">
        <h2 className="text-base sm:text-xl font-medium">{title}</h2>
        {link?.url && (
          <Button
            variant="link"
            asChild
            className="text-sm sm:text-lg p-0 sm:p-2"
          >
            <Link href={link.url} onClick={() => trackSectionClick(id)}>
              {link.text || "Tümünü Gör"}
              <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </Link>
          </Button>
        )}
      </div>
      <CollectionsSwiper collections={items} />
    </section>
  );
};

export default CollectionsSection;
